import { render, staticRenderFns } from "./ButtonToggleText.vue?vue&type=template&id=984172d4"
import script from "./ButtonToggleText.vue?vue&type=script&lang=js"
export * from "./ButtonToggleText.vue?vue&type=script&lang=js"
import style0 from "./ButtonToggleText.vue?vue&type=style&index=0&id=984172d4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports